




















import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import TariffElement from "./partials/tariffs/TariffElement.vue";
import appService from "@/services/appService";
import merge from "@common/modules/vuetifyx/utils/merge";
import BlurredTenant from "@/components/BlurredTenant.vue";
import * as _ from "lodash";

export default Vue.extend({
  components: { TariffElement, BlurredTenant },
  data() {
    const elementTypeItems = [
      { text: "ENERGY", value: "ENERGY" },
      { text: "PARKING TIME", value: "PARKING_TIME" },
    ];
    return {
      showBlur:
        userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) &&
        !!userManager.getUserInfo().tenant?.setting?.expDate &&
        userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      self: this,
      tableContainer: new DataContainer(),
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "name",
          "sort-desc": false,
          "show-expand": true,
        },
        content: {
          name: "Tariffs",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              tenant_id: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Organization",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "tenants",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              limit,
                              search,
                              orderBy: "name",
                              orderType: "asc",
                              filters: [
                                {
                                  key: "_id",
                                  operator: "equal_to",
                                  value,
                                },
                              ],
                            }),
                          }
                        );
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to_id: {},
                },
              },
              charging_station_id: {
                type: "XAutocomplete",
                attrs: {
                  label: "Charging Station",
                  required: false,
                  "item-value": "_id",
                  "item-text": "uniqueId",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const tenant = userManager.getUserInfo().tenant;
                        const filters = [
                          {
                            key: "_id",
                            operator: "equal_to",
                            value,
                          },
                        ];
                        if (tenant) {
                          filters.push({
                            key: "tenantId",
                            operator: "equal_to",
                            value: tenant._id,
                          });
                        }
                        const { items } = await coreApiClient.call(
                          "chargingStations",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              limit,
                              search,
                              orderBy: "name",
                              orderType: "asc",
                              filters,
                            }),
                          }
                        );
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to_id: {},
                },
              },
            },
          },
          displayFields: {
            ChargingStation: {
              text: "Charging Station",
              sortable: true,
              options: {
                subProp: "charging_station.uniqueId",
                label: true,
                sortBy: "uniqueId",
              },
            },
            ConnectorId: {
              text: "Connector ID",
              sortable: true,
              options: {
                subProp: "connector_id",
                label: true,
                sortBy: "connector_id",
              },
            },
            createdTime: {
              text: "Created Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            updatedTime: {
              text: "Updated Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            tenant: userManager.checkRole([
              "systemAdmin",
              "admin",
              "cpoGroup",
            ]) && {
              text: "Organization",
              options: {
                subProp: "tenant.name",
                label: true,
                sortBy: "tenantId",
              },
            },
            action: !userManager.checkRole(["cpoGroup"]) && {
              text: "Actions",
            },
          },
          topActionButtons: {
            insert: userManager.checkRole(["cpoAdmin"]) &&
              !userManager.checkRole(["cpoGroup"], true) && {
                target: {
                  dialog: {
                    attrs: {
                      width: "600px",
                    },
                  },
                },
                ext: {
                  condition() {
                    return appService.activeTenantValid();
                  },
                },
              },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["cpoAdmin"]) &&
                !userManager.checkRole(["cpoGroup"], true) && {
                  target: {
                    dialog: {
                      attrs: {
                        width: "600px",
                      },
                      ext: {
                        subTitleMaker: "uniqueId",
                      },
                    },
                  },
                  ext: {
                    condition(_, item) {
                      return !item.partyId;
                    },
                  },
                },
              delete: userManager.checkRole(["cpoAdmin"]) &&
                !userManager.checkRole(["cpoGroup"], true) && {
                  ext: {
                    condition(_, item) {
                      return !item.partyId;
                    },
                  },
                },
            },
          },
          findAllOptionsFilter(options) {
            const activeTenant = appService.getActiveTenant();
            if (activeTenant) {
              options.filters.push({
                key: "tenant_id",
                operator: "equal_to_id",
                value: activeTenant._id,
              });
            }

            options.extraParams.currentTimeZoneOffset =
              new Date().getTimezoneOffset() * -1 * 60 * 1000;
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const payload = JSON.parse(options.payload || "{}");
              const filters = payload.filters || [];
              if (userManager.checkRole(["cpoAdmin", "cpoMonitor"], true)) {
                const tenantId = userManager.getUserInfo().tenant._id;
                filters.push({
                  key: "tenant_id",
                  operator: "equal_to_id",
                  value: tenantId,
                });
                options.payload = JSON.stringify({
                  ...payload,
                  filters,
                });
              }
              const { items, count } = await coreApiClient.call(
                "tariffs",
                "findAll",
                options
              );

              items.forEach((item) => {
                item.elements = _.map(item.elements, (el) => {
                  return {
                    type: el.price_components[0]?.type,
                    step_size: el.price_components[0]?.step_size,
                    vat: el.price_components[0]?.vat,
                    start_time: el.restrictions?.start_time,
                    end_time: el.restrictions?.end_time,
                    price: el.price_components[0]?.price,
                  };
                });
              });
              return [items, count];
            },
            async insert({ charging_station_id, elements }) {
              const item = {
                charging_station_id,
                elements: elements.map((el) => ({
                  price_components: [
                    {
                      type: el.type,
                      price: el.price,
                    },
                  ],
                  restrictions: {
                    start_time: el.start_time,
                    end_time: el.end_time,
                  },
                })),
              };
              return await coreApiClient.call(
                "tariffs",
                "create",
                undefined,
                item
              );
            },
            async update({ _id, elements }) {
              elements = elements.map((el) => ({
                price_components: [
                  {
                    type: el.type,
                    price: el.price,
                  },
                ],
                restrictions: {
                  start_time: el.start_time,
                  end_time: el.end_time,
                },
              }));
              return await coreApiClient.call(
                "tariffs",
                "update",
                {
                  id: _id,
                },
                {
                  data: {
                    elements,
                  },
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("tariffs", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              charging_station_id: {
                type: "XAutocomplete",
                attrs: {
                  label: "Charging Station",
                  "item-value": "_id",
                  "item-text": "uniqueId",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const tenant = userManager.getUserInfo().tenant;
                        const filters = [
                          {
                            key: "_id",
                            operator: "equal_to",
                            value,
                          },
                        ];
                        if (tenant) {
                          filters.push({
                            key: "tenantId",
                            operator: "equal_to",
                            value: tenant._id,
                          });
                        }
                        const { items } = await coreApiClient.call(
                          "chargingStations",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              limit,
                              search,
                              orderBy: "name",
                              orderType: "asc",
                              filters,
                            }),
                          }
                        );
                        return items;
                      },
                    },
                  },
                },
              },
              elements: {
                type: "XArrayInput",
                attrs: {
                  label: "Elements",
                  required: true,
                  xOptions: {
                    content: {
                      itemLabel: (_, index) => {
                        return `Elements ${+index + 1}`;
                      },
                      itemProperties: {
                        type: {
                          type: "select",
                          attrs: {
                            label: "Type",
                            items: elementTypeItems,
                            required: true,
                            options: {
                              transform(_, item) {
                                console.log("item", item);
                                const price_components = item.price_components;
                                return price_components[0]?.type;
                              },
                            },
                          },
                          ext: {
                              defaultValue: "ENERGY",
                          },
                        },
                        start_time: {
                          attrs: {
                            label: "Start Time",
                            required: true,
                          },
                        },
                        end_time: {
                          attrs: {
                            label: "End Time",
                            required: true,
                          },
                        },
                        price: {
                          type: "number",
                          attrs: {
                            label: "Price(per kWh)",
                            required: true,
                            min: 0,
                            suffix: "per kWh",
                          },
                          ext: {
                            defaultValue: 0,
                          },
                        },
                      },
                      template: {
                        formOptions: {
                          content: {
                            colLength: 12,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            insertForm: userManager.checkRole([
              "systemAdmin",
              "admin",
              "cpoAdmin",
            ]) && {
              content: {
                fieldNames: ["charging_station_id", "elements"],
              },
            },
            editForm: userManager.checkRole(["cpoAdmin"]) && {
              content: {
                fieldNames: ["elements"],
              },
            },
            delete: {
              confirmDisplayField: "_id",
            },
          },
        },
      },
    };
  },
  methods: {
    updateChargingStation(item) {
      const dataTable = this.tableContainer.value;
      const index = dataTable.items.value.findIndex(
        (it) => it.uniqueId === item.uniqueId
      );
      if (index >= 0) {
        const previousItem = dataTable.items.value[index];
        this.$set(
          dataTable.items.value,
          index,
          merge.clone(previousItem, item)
        );
      }
    },
  },
});
